import { CREATE_TICKET, CREATE_TICKET_SUCCESS, CREATE_TICKET_ERROR } from "../actions";

const INIT_STATE = {
	createdTicket: null,
	loading: false,
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case CREATE_TICKET:
			return { ...state, loading: true };

		case CREATE_TICKET_SUCCESS:
			return { ...state, loading: false, createdTicket: action.payload };

		case CREATE_TICKET_ERROR:
			return { ...state, loading: false, error: action.payload };

		default: return { ...state };
	}
}
